interface Team {
  teamId: string;
  name: string;
  description?: string;
  memberCount?: number;
  role?: 'admin' | 'member';
  status: 'active' | 'deactivated';
}


interface TeamCardProps {
  team: Team;
  onTeamUpdate: () => void;
}

export function TeamCard({ team }: TeamCardProps) {
  const canManageTeam = team.role === 'admin';

  const handleTeamClick = () => {
    window.location.href = `/teams/${team.teamId}`;
  };

  const handleInviteMembers = (e: Event) => {
    e.stopPropagation();
    window.location.href = `/teams/${team.teamId}/invite`;
  };

  const getRoleIcon = (role?: string) => {
    return role === 'admin' ? '⭐' : '👤';
  };

  const getStatusBadge = (status: string) => {
    if (status === 'deactivated') {
      return <span class="badge badge-error badge-sm">Deactivated</span>;
    }
    return null;
  };

  return (
    <div
      class="card bg-base-100 shadow-md hover:shadow-lg transition-shadow cursor-pointer"
      onClick={handleTeamClick}
    >
      <div class="card-body">
        <div class="flex justify-between items-start mb-3">
          <h3 class="card-title text-lg">{team.name}</h3>
          {getStatusBadge(team.status)}
        </div>

        {team.description && (
          <p class="text-sm text-base-content/70 mb-3 line-clamp-2">
            {team.description}
          </p>
        )}

        <div class="flex items-center gap-2 text-sm text-base-content/70 mb-4">
          <span class="flex items-center gap-1">
            {getRoleIcon(team.role)}
            <span class="capitalize">{team.role ?? 'member'}</span>
          </span>
          <span>•</span>
          <span class="flex items-center gap-1">
            👥 {team.memberCount ?? 0} member{(team.memberCount ?? 0) !== 1 ? 's' : ''}
          </span>
        </div>


        <div class="card-actions justify-end">
          {canManageTeam && (
            <>
              <button
                class="btn btn-sm btn-primary"
                onClick={handleInviteMembers}
                title="Invite team members"
              >
                + Invite
              </button>
              <button
                class="btn btn-sm btn-ghost"
                onClick={(e) => {
                  e.stopPropagation();
                  window.location.href = `/teams/${team.teamId}/settings`;
                }}
              >
                Settings
              </button>
            </>
          )}

          {team.role === 'member' && (
            <button
              class="btn btn-sm btn-ghost"
              onClick={(e) => {
                e.stopPropagation();
                window.location.href = `/teams/${team.teamId}/members`;
              }}
            >
              View Members
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
